// @ts-nocheck
/**
 * sliderRenderer.ts — Template V2 SLIDER_RENDERER (DEC-059)
 */

import { componentInteractionProps } from './interactionProps';
import { applyExpressionFallback, buildDescriptor, resolveValue } from './rendererUtils';
import {
  coerceSliderNumber,
  isSliderOutOfBounds,
  SLIDER_DEFAULT_MAX,
  SLIDER_DEFAULT_MIN,
} from './sliderUtils';
import type { CompiledPropsByType, ComponentRenderer } from './types';
import { extractTypedProps } from './types';

export const SLIDER_RENDERER: ComponentRenderer<CompiledPropsByType['slider']> = {
  supportedType: 'slider',
  render(context) {
    const issuesBefore = context.issues.length;
    const { visible, enabled } = applyExpressionFallback(context);
    const p = extractTypedProps('slider', context.node.props);

    const value = coerceSliderNumber(resolveValue(p.slider.source, context) as unknown);
    const minResolved = coerceSliderNumber(
      p.slider.min != null ? resolveValue(p.slider.min, context) : SLIDER_DEFAULT_MIN,
    );
    const maxResolved = coerceSliderNumber(
      p.slider.max != null ? resolveValue(p.slider.max, context) : SLIDER_DEFAULT_MAX,
    );
    const min = minResolved ?? SLIDER_DEFAULT_MIN;
    const max = maxResolved ?? SLIDER_DEFAULT_MAX;
    const valueType = p.slider.valueType ?? 'float';
    const orientation = p.slider.orientation ?? 'horizontal';
    const step = p.slider.step;
    const editable = p.slider.editable ?? true;

    const isOutOfBounds =
      value != null ? isSliderOutOfBounds(value, min, max) : false;

    if (isOutOfBounds && value != null) {
      context.issues.push({
        severity: 'warning',
        code: 'schema.invalid_field_type',
        message:
          `Slider value ${value} out of range [${min}, ${max}] for node "${context.node.id}"; ` +
          'indicated as out-of-bounds but not clamped.',
        path: context.node.id,
      });
    }

    return buildDescriptor(context.node, visible, enabled, {
      value,
      min,
      max,
      step: step ?? null,
      valueType,
      orientation,
      editable,
      isOutOfBounds,
      ...componentInteractionProps(context.node),
    }, { diagnostics: context.issues.slice(issuesBefore), renderContext: context });
  },
};
